import React from "react";
import { useNavigate } from "react-router-dom";

export const StatusBadge = ({ s }) => {
  const map = {
    approved: "bg-green-100 text-green-800",
    declined: "bg-red-100 text-red-800",
    cancelled: "bg-gray-200 text-gray-700",
    pending: "bg-amber-100 text-amber-800",
  };
  return <span className={`px-2 py-0.5 rounded text-[10px] uppercase tracking-widest ${map[s] || map.pending}`}>{s}</span>;
};

export function DashboardHeader({ title, subtitle, user, onLogout, onChangePassword }) {
  const nav = useNavigate();
  return (
    <header className="bg-white border-b border-[var(--border)]">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-5 flex items-center justify-between flex-wrap gap-3">
        <div>
          <h1 className="font-display text-3xl">{title}</h1>
          <p className="text-xs uppercase tracking-widest text-[var(--muted)]">{subtitle || (user ? `${user.name} · ${(user.role||"").replace("_"," ")}` : "")}</p>
        </div>
        <div className="flex items-center gap-3 flex-wrap">
          {onChangePassword && <button onClick={onChangePassword} className="text-xs uppercase tracking-widest hover:text-[var(--accent)]" data-testid="change-pwd">Change Password</button>}
          <a href="/" className="text-sm uppercase tracking-widest hover:text-[var(--accent)]">Site</a>
          <button onClick={async () => { await onLogout(); nav("/"); }} className="btn-outline rounded-full px-5 py-2 text-xs tracking-widest uppercase" data-testid="logout-btn">Logout</button>
        </div>
      </div>
    </header>
  );
}

export function StatCard({ label, value, accent }) {
  return (
    <div className={`bg-white border border-[var(--border)] p-5 ${accent ? "border-l-4 border-l-[var(--accent)]" : ""}`}>
      <p className="text-xs uppercase tracking-widest text-[var(--muted)]">{label}</p>
      <p className="font-display text-4xl mt-1">{value ?? 0}</p>
    </div>
  );
}

export function Tabs({ tabs, current, onChange, prefix = "tab" }) {
  return (
    <div className="flex gap-2 border-b border-[var(--border)] overflow-x-auto">
      {tabs.map(t => (
        <button key={t.k} onClick={() => onChange(t.k)} data-testid={`${prefix}-${t.k}`}
          className={`px-5 py-3 text-sm uppercase tracking-widest border-b-2 -mb-[1px] whitespace-nowrap ${current === t.k ? "border-[var(--accent)] text-[var(--text)]" : "border-transparent text-[var(--muted)]"}`}>
          {t.label} {t.count > 0 && <span className="ml-1.5 bg-[var(--accent)] text-white text-[10px] px-2 py-0.5 rounded-full">{t.count}</span>}
        </button>
      ))}
    </div>
  );
}

export const Empty = ({ msg }) => <div className="bg-white border border-[var(--border)] p-12 text-center text-[var(--muted)]">{msg}</div>;

export function fmtTs(iso) {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleString(); } catch { return iso; }
}

export function fmtTime12(t24) {
  if (!t24 || !t24.includes(":")) return t24 || "—";
  const [h, m] = t24.split(":").map(Number);
  const meridiem = h < 12 ? "AM" : "PM";
  const hh12 = h === 12 ? 12 : h > 12 ? h - 12 : h || 12;
  return `${hh12}:${String(m).padStart(2, "0")} ${meridiem}`;
}
